<fieldset [class.expanded]="expanded">
  @if (!expanded) {
  <div class="content brief">
    <label>Password</label>
    @if (hasPassword) {
    <div>********</div>
    } @if (!hasPassword) {
    <empty>No password has been set yet</empty>
    } @if (!disabled) {
    <div class="edit">
      @if (isEditable | async) {
      <a (click)="expand()"> edit </a>
      } @else { @if (hasPassword) {
      <a (click)="config.openResetDialog()"> send password reset email </a>
      } @if (!hasPassword) {
      <a (click)="config.openWelcomeDialog()"> send welcome email </a>
      } }
    </div>
    }
  </div>
  } @if (expanded) {
  <div class="content" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <label>Password</label>
    <form [formGroup]="form" (submit)="submit()">
      <p>
        Password must contain at least {{ minPasswordLength }} characters,
        including {{ minPasswordNumbers }}
        <span> {{ minPasswordNumbers > 1 ? 'numbers' : 'number' }} </span> and
        {{ minPasswordSymbols }}
        <span> {{ minPasswordSymbols > 1 ? 'symbols' : 'symbol' }}. </span>
      </p>
      <div class="control-wrap">
        <div class="control">
          <input
            type="password"
            formControlName="oldPassword"
            placeholder="Old password"
            class="form-control"
          />
        </div>
        <field-errors [controls]="form.controls.oldPassword"></field-errors>
        <ng-container formGroupName="newPassword">
          <div class="control new-psw">
            <input
              type="password"
              formControlName="password"
              placeholder="New password"
              class="form-control"
            />
            <password-strength
              [password]="passwordControl.value"
            ></password-strength>
          </div>
          <field-errors [controls]="passwordControl"></field-errors>
          <div class="control">
            <input
              type="password"
              formControlName="confirm"
              placeholder="Confirm new password"
              class="form-control"
            />
          </div>
          <field-errors [controls]="confirmControl"></field-errors>
        </ng-container>
        <field-errors [controls]="form.controls.newPassword"></field-errors>
      </div>
      <submit-control (cancel)="cancel()">Save changes</submit-control>
    </form>
  </div>
  }
</fieldset>
